var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('img',{staticStyle:{"max-width":"100%","max-height":"100%","margin-left":"10px","width":"325px","height":"325px"},attrs:{"src":require("../../assets/logo-preta.png")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }